import * as React from "react"
import * as ReactDOM from "react-dom"
import "../common"
import "./index.css"

import config from "../../utils/config"
import request from "../../utils/request"
import { GetQueryString } from "../../utils/utils"
import "../../components/shop/common"
import TakePhone from "../shop/take-phone"
import Language from "./language"

interface InterProps {
  isCollect?: number | undefined // 0 活动-未关注 1 活动-已关注
  url?: string
  collectCallBack?(status: any): void
}

export default class Header extends React.Component<InterProps, any> {
  private navRef
  constructor(props: any) {
    super(props)
    this.state = {
      btn: false,
      cardInfo: "", // 卡片信息
      cardShow: false, // 卡片显示控制
      attentShow: false, // 关注弹窗
      infoData: "", // 头部信息
      pathName: "",
      timePoupShow: false, // 显示店铺年限
      isMiniBaiduProgram: (window as any).isMiniBaiduProgram, // 是否在百度小程序中
      shopId: "", // 店铺id
      shopDomain: "", // 店铺域名
      modelsId: "", // 模板id
      styleConfig: {},
      styleShow: false,
      showTopone: false, // 显示镇店之宝
      searchValue: decodeURIComponent(GetQueryString("keyword" || "")),
    }
    this.navRef = React.createRef()
  }

  public componentWillMount() {
    this._getId()
  }

  public componentDidMount() {
    this._getCardInfo()
    this.getTopAd()
    // 头部面板控制
    const path = window.location.pathname
    const btn = false // 面板按钮

    this.setState({
      pathName: path,
    })
  }

  public componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return
    }
  }

  public render() {
    const state = this.state
    return (
      <div>
        {state.cardShow || state.attentShow ? (
          <div>
            <div className="touming"></div>
            {state.cardShow && (
              <div className="shopCard" style={{ display: "block" }}>
                <div className="shop-info">
                  <h2>{state.cardInfo.companyName}</h2>
                  <p>
                    {state.cardInfo.seller_grade ? (
                      <img src={state.cardInfo.seller_grade} />
                    ) : null}
                    <span>企业类型：{state.cardInfo.companyCategoryValue}</span>
                  </p>
                </div>
                <ul>
                  <li>
                    <b>联系人：</b>
                    <span>{state.cardInfo.contact}</span>
                  </li>
                  <li>
                    <b>职务：</b>
                    <span>{state.cardInfo.position}</span>
                  </li>
                  {/*  {
                                            state.cardInfo.contact_tel && <li><b>联系方式：</b> <a href={`tel:${state.cardInfo.contact_tel}`}><span className="tel">{state.cardInfo.contact_tel}</span></a></li>
                                        }
                                        {
                                            state.cardInfo.contact_tel && state.cardInfo.contact_phone && <li><b></b> <a href={`tel:${state.cardInfo.contact_phone}`}><span className="tel">{state.cardInfo.contact_phone}</span></a></li>
                                        }
                                        {
                                            !state.cardInfo.contact_tel && state.cardInfo.contact_phone && <li><b>联系方式：</b> <a href={`tel:${state.cardInfo.contact_phone}`}><span className="tel">{state.cardInfo.contact_phone}</span></a></li>
                                        }*/}
                  <li>
                    <b>联系方式：</b>{" "}
                    <a href="javascript: void(0)">
                      <span
                        className="tel"
                        onClick={() => this.takePhoneHandle()}
                      ></span>
                    </a>
                  </li>
                  <li>
                    <b>公司地址：</b>
                    <span>{state.cardInfo.address}</span>
                  </li>
                </ul>
                <span
                  className="closeBtn"
                  onClick={() => this._showCard(false)}
                ></span>
              </div>
            )}
            {state.attentShow && (
              <div
                className="success shop_collect"
                style={{ display: "block" }}
              >
                <p className="collect-tips">
                  <img
                    className="tips-img"
                    src="https://style.ibuychem.com/wiseshop/pc/images/right.png"
                  />
                  <span>
                    {state.infoData.is_collect === 1 ? "关注" : "取消"}成功
                  </span>
                </p>
                <p className="display-word">
                  您已成功{state.infoData.is_collect === 1 ? "" : "取消"}
                  关注该店铺！
                </p>
                <span
                  className="close"
                  onClick={() => this.toggleAttention(false)}
                ></span>
              </div>
            )}
          </div>
        ) : null}
        <header className="main-header">
          <div
            className="shop"
            style={{
              background: `url(${
                this.state.topAd || this.state.styleConfig.wap_top_advertising
              }) center top repeat-x`,
              color: "#666",
            }}
          >
            <div className="shop-name">
              <div className="shop-name-title">
                <h2>
                  {state.infoData.shop_name
                    ? state.infoData.shop_name.substr(0, 16)
                    : ""}
                </h2>
                {state.infoData.shop_name &&
                state.infoData.shop_name.length > 16 ? (
                  <img src={require("../../assets/images/msp_04.png")} />
                ) : (
                  ""
                )}
              </div>
              <div>
                <p className="header-small-icon">
                  {state.infoData.activity_tag === "1" ? (
                    <img
                      className="label-join"
                      src={require("../../assets/images/icon-join.png")}
                    />
                  ) : null}
                  {state.infoData.tags_img &&
                  state.infoData.member_type !== "免费店铺"
                    ? state.infoData.tags_img.map((v: any, k: number) => {
                        return (
                          <i
                            style={{
                              background: `url(${v}) no-repeat`,
                              backgroundSize: "100%, 100%",
                            }}
                            key={`headerIcon${k}`}
                          />
                        )
                      })
                    : null}
                  {state.infoData.member_type}

                  <span onClick={() => this._showTimePoup()}>
                    {state.infoData.year}年
                  </span>
                </p>
                <p className="header-small-icon icon-article-num">
                  <i className="wzs"></i>
                  <span>{state.infoData.article_count}</span>
                </p>
                <p className="header-small-icon icon-article-read">
                  <em>浏览量</em>
                  <span>{state.infoData.traffic_total}</span>
                </p>
              </div>
            </div>
            <div className="shop-mp" onClick={() => this._showCard(true)}>
              <span>
                <img src={require("../../assets/images/msp_03.png")} />
              </span>
            </div>
            {typeof this.props.isCollect !== "undefined" ? (
              <div className="shop-follow" onClick={() => this._collect(0)}>
                {" "}
                <span>
                  {this.props.isCollect === 1 ? "已关注" : "未关注"}
                </span>{" "}
              </div>
            ) : (
              <div className="shop-follow" onClick={() => this._collect(1)}>
                {" "}
                <span>
                  {Number(state.infoData.is_collect) === 1
                    ? "已关注"
                    : "未关注"}
                </span>{" "}
              </div>
            )}
            <Language
              lan="1"
              url={this.props.url}
              shopInfo={this.state.infoData}
            />
          </div>
          {this.showShopData()}
          <div className="search_menu">
            <div className="search-ss">
              <img src={require("../../assets/images/msp_05.png")} />
              <input
                type="text"
                name=""
                placeholder="搜索"
                id="myInput"
                onChange={() => this._search(event)}
                onKeyDown={() => this._searchConfirm(event)}
                value={this.state.searchValue}
              />
            </div>
            <div
              className="nav-layout1"
              style={{ display: this.state.styleShow ? "block" : "none" }}
            >
              <ul
                className={`nav ${this.state.isMiniBaiduProgram ? "row3" : ""}`}
                ref={this.navRef}
              >
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            state.pathName === "/" ||
                              state.pathName === "/m" ||
                              state.pathName === "/m/"
                          )
                        : {}
                    }
                    className={
                      state.pathName === "/" ||
                      state.pathName === "/m" ||
                      state.pathName === "/m/"
                        ? "current"
                        : ""
                    }
                    onClick={() => this._push("/m")}
                  >
                    首页
                  </a>
                </li>
                {this.state.showTopone && (
                  <li>
                    <a
                      style={
                        this.state.styleConfig
                          ? this.getStyle(
                              this.state.styleConfig,
                              this.isCurrentPath("/topone")
                            )
                          : {}
                      }
                      className={this.isCurrentPath("/topone") ? "current" : ""}
                      onClick={() => this._push("/m/topone")}
                    >
                      镇店之宝
                    </a>
                  </li>
                )}
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/offerlist")
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/offerlist") ? "current" : ""
                    }
                    onClick={() => this._push("/m/offerlist")}
                  >
                    供应商品
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/courses")
                          )
                        : {}
                    }
                    className={this.isCurrentPath("/courses") ? "current" : ""}
                    onClick={() => this._push("/m/courses")}
                  >
                    在线课堂
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/experts")
                          )
                        : {}
                    }
                    className={this.isCurrentPath("/experts") ? "current" : ""}
                    onClick={() => this._push("/m/experts")}
                  >
                    专家论文
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/datasheet")
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/datasheet") ? "current" : ""
                    }
                    onClick={() => this._push("/m/datasheet")}
                  >
                    优料库
                  </a>
                </li>
                <li>
                  <a
                    style={
                      this.state.styleConfig
                        ? this.getStyle(
                            this.state.styleConfig,
                            this.isCurrentPath("/storeintro")
                          )
                        : {}
                    }
                    className={
                      this.isCurrentPath("/storeintro") ? "current" : ""
                    }
                    onClick={() => this._push("/m/storeintro")}
                  >
                    公司介绍
                  </a>
                </li>
                {this.state.infoData.member_type !== "免费店铺" &&
                !this.state.isMiniBaiduProgram ? (
                  <li>
                    <a
                      style={
                        this.state.styleConfig
                          ? this.getStyle(
                              this.state.styleConfig,
                              this.isCurrentPath("/zx")
                            )
                          : {}
                      }
                      className={this.isCurrentPath("/zx") ? "current" : ""}
                      onClick={() => this._push("/m/zx")}
                    >
                      公司动态
                    </a>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </header>
        {this.props.children
          ? React.cloneElement(this.props.children as any, {
              showTopone: state.showTopone,
            })
          : ""}

        <div
          className="head-dialog"
          style={{ display: this.state.timePoupShow ? "block" : "none" }}
        >
          {`${
            this.state.infoData.member_type
              ? this.state.infoData.member_type
              : ""
          }： ${this.state.infoData.service_begin}-${
            this.state.infoData.service_end
          }`}
        </div>
        <TakePhone phone={this.state.cardInfo.contact_tel} />
      </div>
    )
  }

  private getQueryString(name: string) {
    const reg = new RegExp("(^|/?|&)" + name + "=([^&]*)(&|$)", "i")
    const r = decodeURIComponent(location.href).substr(1).match(reg)
    if (r != null) {
      return r[2]
    }
    return null
  }

  // 获取样式
  private async _getStyle() {
    const r = request({
      url: config.PHPAPI + "api/wshop/shop/get-models",
      method: "post",
      data: {
        shopId: this.state.shopId,
        shopDomain: this.state.shopDomain,
        modelsId: this.state.modelsId,
      },
    })

    r.then((res) => {
      if (res.error_code === 0) {
        this.setState({
          styleConfig: res.data.wap_configuration,
          styleShow: true,
        })
      }
    })
  }

  // 获取企业id
  private async _getId() {
    const path: any = (window as any).shopId
    const r = request({
      data: {
        shopDomain: path,
      },
      method: "post",
      url: config.PHPAPI + "api/wshop/shop/shop-info",
    })

    r.then((res) => {
      if (res.error_code === 0) {
        document.title = res.data[0].shop_name

        // 修改店铺名称
        res.data[0].shop_name += "智慧商铺"
        this.setState(
          {
            shopId: res.data[0].shop_id || "",
            modelsId: this.getQueryString("modelsId") || res.data[0].models_id,
            shopDomain: res.data[0].shop_domain || "",
            infoData: res.data[0],
          },
          () => {
            this._getStyle()

            this.getTreasureInfo()
          }
        )
      }
    })
  }

  private async getTreasureInfo() {
    const r = await request({
      data: {
        shopId: this.state.shopId,
      },
      method: "get",
      url: config.PHPAPI + "api/shop/goods/get-treasure",
    })

    if (r.error_code === 0) {
      if (r.data.treasure) {
        this.setState({
          showTopone: true,
        })
      }
    }

    let scrollPosition = r.data && r.data.treasure ? 30 : 0
    switch (this.state.pathName) {
      case "m/experts/":
        scrollPosition += 0
        break
      case "/m/datasheet/":
        scrollPosition += 100
        break
      case "/m/storeintro/":
        scrollPosition += 130
        break
      case "/m/zx/":
        scrollPosition += 200
        break
      default:
        scrollPosition = 0
        break
    }
    this.navRef.current.scrollLeft = scrollPosition
  }

  private getStyle(data: any, isChecked?: boolean) {
    const styles: any = {}

    styles.color = data.wap_top_font ? data.wap_top_font : ""
    if (isChecked) {
      styles.color = data.wap_top_font_selected
        ? data.wap_top_font_selected
        : ""
      styles.borderBottomColor = data.wap_bottom_selected
        ? data.wap_bottom_selected
        : ""
    }

    return styles
  }

  private _showTimePoup() {
    const that = this
    if (!this.state.timePoupShow) {
      this.setState(
        {
          timePoupShow: true,
        },
        () => {
          const timer = setTimeout(function () {
            that.setState({
              timePoupShow: false,
            })
            clearTimeout(timer)
          }, 1500)
        }
      )
    }
  }

  private _push(url: string) {
    window.location.href = url + "/"
  }

  // 修改关注状态
  private async _collect(type: number) {
    const SHOP_ID = (window as any).shopId
    const r = await request({
      data: {
        collType: 1,
        shopDomain: SHOP_ID,
      },
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/shop/collection`,
    })
    if (r.error_code === 0) {
      if (type === 0) {
        this.props.collectCallBack &&
          this.props.collectCallBack(this.props.isCollect === 1 ? 0 : 1)
      } else {
        const temp = this.state.infoData
        temp.is_collect = Number(temp.is_collect) === 1 ? 0 : 1
        this.toggleAttention(true)
        this.setState({
          infoData: temp,
        })
      }
    }
  }

  // 显示名片
  private _showCard(open: boolean) {
    this.setState(
      {
        cardShow: open,
      },
      () => {
        if (!open || this.state.cardInfo !== "") {
          return
        }
      }
    )
  }

  // 获取名片信息
  private async _getCardInfo() {
    const path: any = (window as any).shopId
    const r = await request({
      data: {
        shopDomain: path,
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/shop/shop-card`,
    })

    if (r.error_code === 0) {
      this.setState({
        cardInfo: r.msg,
      })
    }
  }
  // 搜索
  private _search(e: any) {
    this.setState({
      searchValue: e.srcElement.value,
    })
  }
  private _searchConfirm(e) {
    if (e.keyCode === 13) {
      const keyword = encodeURIComponent(e.srcElement.value)
      window.location.href =
        window.location.origin +
        "/m/offerlist?keyword=" +
        encodeURIComponent(keyword)
    }
  }

  /**
   * [toggleAttention 关注弹层]
   * @param  {[boolean]} visible [显示隐藏关注弹窗]
   */
  private toggleAttention(visible: boolean) {
    this.setState({
      attentShow: visible,
    })
  }

  private isCurrentPath(pathName: string) {
    return this.state.pathName.indexOf(pathName) > -1
  }

  // 拨打加密电话
  private async takePhoneHandle() {
    window.location.href =
      "tel:" +
      (this.state.infoData.contact_tel ||
        this.state.infoData.contact_phone ||
        "15907538884")
    return
    const gid =
      window.location.pathname.indexOf("/offer/") > -1
        ? GetQueryString("id")
        : ""
    const r = request({
      data: {
        shopDomain: (window as any).shopId,
        gid,
      },
      method: "post",
      url: config.PHPAPI + "api/wshop/default/bind",
    })

    r.then((res) => {
      if (res.error_code === 0) {
        window.location.href = "tel:" + res.data.tel
      } else {
        ;(window as any).alert(res.msg)
      }
    })
  }

  // 获取顶部广告位
  private async getTopAd() {
    const path: any = (window as any).shopId

    const r = request({
      data: {
        shopDomain: path,
      },
      method: "post",
      url: config.PHPAPI + "api/wshop/shop/special",
    })

    r.then((res) => {
      if (res.error_code === 0) {
        const topAd = res.data[0]
        this.setState({
          topAd:
            topAd && topAd.banner_sys_id === "4"
              ? topAd.banner_info[0].banner_img
              : "",
        })
      }
    })
  }

  private showShopData() {
    if (
      this.state.infoData.product_quality === "0.00" &&
      this.state.infoData.technological_innovation === "0.00" &&
      this.state.infoData.cost_performance === "0.00" &&
      this.state.infoData.chain_services === "0.00" &&
      this.state.infoData.sales_service === "0.00"
    ) {
      return null
    }
    return (
      <div className="my-info">
        <div className="info-num">
          <span className="item">{this.state.infoData.product_quality}</span>
          <span className="item">
            {this.state.infoData.technological_innovation}
          </span>
          <span className="item">{this.state.infoData.cost_performance}</span>
          <span className="item">{this.state.infoData.chain_services}</span>
          <span className="item">{this.state.infoData.sales_service}</span>
        </div>
        <div className="info-box">
          <div className="info-item">商品</div>
          <div className="info-item">技术</div>
          <div className="info-item">响应</div>
          <div className="info-item info-item-xd">支持</div>
          <div className="info-item">供货</div>
        </div>
      </div>
    )
  }
}

ReactDOM.render(<Header />, document.getElementById("root") as HTMLElement)



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx